<div fxLayout="column" fxLayoutAlign="start center" class="container">
  <h3>
    Your invitation has expired.
    <br />
    Please contact your lineup administrator to receive another invitation.
  </h3>
</div>
